import { API, graphqlOperation } from 'aws-amplify';
import { batch, useDispatch, useSelector } from 'react-redux';
import { IState, Subscription } from '../../graphql/types';
import useUser from '../useUser';
import gql from 'graphql-tag';
import {
  addImageSubscriptionId,
  removeImageSubscriptionId,
  updateSubscription,
} from '../../actions';
import { message } from 'antd';

const onUpdateUserImageRecord = gql`
  subscription onUpdateUserImageRecord($userID: String!) {
    onUpdateUserImageRecord(userID: $userID) {
      id
      userID
      state
      errorMessageDisplayToUser
    }
  }
`;

type OnUpdateUserImageRecordType = {
  onUpdateUserImageRecord: {
    id: string;
    userID: string;
    state?: string;
    errorMessageDisplayToUser?: string;
  };
};

const useImageUploadSubscription = () => {
  const dispatch = useDispatch();
  const subscription = useSelector<IState, Subscription | undefined>(
    state => state.subscriptions.imageUpload
  );

  const { user } = useUser();

  const subscribe = (giideId, feedCardId) => {
    if (subscription) {
      subscription.unsubscribe();
    }

    const observable = API.graphql(
      graphqlOperation(onUpdateUserImageRecord, {
        id: giideId,
        userID: user?.userId,
      })
    );

    if ('subscribe' in observable) {
      dispatch(addImageSubscriptionId(feedCardId));

      const newSub = observable.subscribe({
        next: async (next: {
          value: { data: OnUpdateUserImageRecordType };
        }) => {
          const result = next.value.data.onUpdateUserImageRecord;

          if (result.state === 'finished' || result.errorMessageDisplayToUser) {
            newSub.unsubscribe();

            // TODO Need to handle error during upload, e.g.
            if (result.errorMessageDisplayToUser) {
              message.error(result.errorMessageDisplayToUser);
            }

            batch(() => {
              dispatch(updateSubscription('imageUpload', undefined));
              dispatch(removeImageSubscriptionId(feedCardId));
            });
          }
        },
      });

      dispatch(updateSubscription('imageUpload', newSub));
    }
  };

  return {
    subscribe,
  };
};

export default useImageUploadSubscription;
